import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import styles from "../../styles/components/demandEdit.module.scss";
import Icons from "../../public/assets/svg";
import DropDown from "../listWithoutcheck";
import utility from "../../utility/endpoints";
import axios from "axios";
import BasicForm from "../basicForm";
import { useRouter } from "next/router";
import SuccessModal from "../../pages/successModal";
const { baseUrl } = utility;
import Loader from "../Loader";
import { sessionTimeOutCheck, checkExpiry } from "../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const ModalExample = (props) => {
  //console.log();
  //console.log("Demaand data  ---", props.demandEditData);
  const router = useRouter();
  const [lodaing, setLoading] = useState(true);
  const [newDemand, setNewDemand] = React.useState(false);
  const [successModal, setSuccessModal] = React.useState(false);
  const [message, setMessage] = React.useState("Demand Updated Successfully!");
  const {
    demandFormData: { field_demand_edit_new_row_detail, field_title },
  } = props;

  const [state, setState] = React.useState({});
  const [submitForm, setSubmitForm] = React.useState(false);
  const [getFormValues, setGetFormValues] = React.useState(false);
  const [emptyFormValues, setEmptyFormValues] = React.useState(false);

  const modalRef = React.useRef(null);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        //console.log(ref.current, "lllllll");
        //console.log(event.target, "eeeeeee");
        if (ref.current && !ref.current.contains(event.target)) {
          //props.closeModal();
        }
      }

      // Bind the event listener
      document.addEventListener("click", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideAlerter(modalRef);

  const submitDemandForm = () => {
    setGetFormValues(true);
    props.setState({ ...props.initialState });
    props.setSearchState("");
    props.setFilterOn(false);
    //props.setPaginationNum(1);
  };

  const recievedFormValues = (formState) => {
    //console.log(formState, "formState is here");
    setState({ ...state, ...formState });
    sendData({ ...state, ...formState });
  };

  //   React.useEffect(() => {
  //     if (submitForm == true){
  // console.log("submitform")

  //     }

  //   }, [submitForm]);

  const convertToDDMMYYYY = (date, Z) => {
    //console.log(date, "this is what I'm getting", Z);
    let year = date.slice(0, 4);
    let month = date.slice(5, 7);
    let day = date.slice(8, 10);

    let newDate = day + "-" + month + "-" + year;
    return newDate;
  };

  const convertToYYYYMMDD = (date) => {
    //console.log(date, "dateiswhat");
    let day = date.slice(0, 2);
    let month = date.slice(3, 5);
    let year = date.slice(6, 10);
    let newDate = year + "-" + month + "-" + day;
    return newDate;
  };

  React.useEffect(() => {
    if (props.demandEditData != null) {
      {/*console.log(
        props.demandEditData.sessionDate,
        "sessionDate",
        props.demandEditData.sessionDate.split("T")[0]
      );*/}

      // props.demandEditData.sessionDate = convertToYYYYMMDD(props.demandEditData.sessionDate)

      setState(props.demandEditData);
    } else if (props.demandEditData == null) {
      //console.log("else new demand");
      setNewDemand(true);
    }
  }, []);

  let arrangedArray = [];

  // field_demand_edit_new_row_detail.map((item, index) => {
  //   if (
  //     item.field_input_type == "Radio" ||
  //     item.field_input_type == "Plain Text"
  //   ) {
  //     arrangedArray.push(item);
  //   } else if (item.field_input_type == "Dropdown1") {
  //     let dropDownAr = [];
  //     dropDownAr.push(item);
  //     dropDownAr.push(field_demand_edit_new_row_detail[index + 1]);

  //     arrangedArray.push(dropDownAr);
  //   }
  // });

  // to convert labels into camelcase
  function camelize(str) {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  }

  const sendData = async (statess) => {
    //console.log(statess, "statesss");
    try {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
   

      statess.sessionDate = convertToYYYYMMDD(statess.sessionDate);
      if (newDemand == true) {
        //console.log("demandObject---", statess);
        
        let authCheck = JSON.parse(localStorage.getItem("auth")).data;
        let expiryStatus = await props.checkExpiry(authCheck);

        if (expiryStatus) {
          let auth = JSON.parse(localStorage.getItem("auth")).data;
          props.setmodalactive(false)
          props.setLoading(true)
          axios({
            method: "post",
            url: `${baseUrl}/demands/createDemand`,
            headers: {
              Authorization: `${auth.accessToken}|${auth.email}`,
            },
            data: statess,
          }).then((resp) => {
            //console.log("resp", resp);
            if (resp.data.code == 403) {
              localStorage.removeItem("auth");
              sessionStorage.clear();
              props.sessionTimeOutCheck(true);
              setLoading(false)
              props.setLoading(false)
            } else if (resp.data.code == 200) {
              props.closeModal("create");
              
             
              
            }
            setState({});
          });
        } else {
          props.sessionTimeOutCheck(true);
          setLoading(false)
          props.setLoading(false)
        }
      } else {
        //console.log("satetes -------", statess);

        let authCheck = JSON.parse(localStorage.getItem("auth")).data;
        let expiryStatus = await props.checkExpiry(authCheck);

        if (expiryStatus) {
          let auth = JSON.parse(localStorage.getItem("auth")).data;
          props.setmodalactive(false)
          props.setLoading(true)
          axios({
            method: "put",
            url: `${baseUrl}/demands/updateDemand`,
            headers: {
              Authorization: `${auth.accessToken}|${auth.email}`,
            },
            data: {
              emailAndSerialNumber: {
                UserEmail: auth.email,
                rowKey: state.rowKey,
              },
              demandUpdateFields: { ...statess },
            },
          }).then((resp) => {
            if (resp.data.code == 403) {
              localStorage.removeItem("auth");
              sessionStorage.clear();
              props.sessionTimeOutCheck(true);
              setLoading(false)
              props.setLoading(false)
            } else if (resp.data.code == 200) {
              
              props.closeModal("update");
            }

            setState({});
            //  props.closeModal();
          });
        } else {
          props.sessionTimeOutCheck(true);
          setLoading(false)
          props.setLoading(false)
        }
      }
    } catch (e) {}
  };
  const editmodal = () => {
    props.closeModal();
    document.body.style.overflow = "unset";
  };
  return (
    <div className={styles.editModalWrapper}>
      <div className={styles.modalBox} ref={modalRef}>
        <div className={styles.modalHeader}>
          <p className={styles.content}>{field_title}</p>
        </div>
        <div className={styles.modalBody}>
          <BasicForm
            data={field_demand_edit_new_row_detail}
            sendFormValues={recievedFormValues}
            getFormValues={getFormValues}
            emptyFormValues={emptyFormValues}
            formType="demand"
            params="demandModal"
            editState={state}
            demandEditData={props.demandEditData}
            setGetFormValues={setGetFormValues}
          />
        </div>
        <div className={styles.ModalFooter}>
          <div className={styles.combinedBtn}>
            <span
              className={styles.rowBtn}
              onClick={() => {
                editmodal();
              }}
            >
              Cancel
            </span>
            <span className={styles.exportListBtn} onClick={submitDemandForm}>
              Save Details
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalExample);
